import { Link } from "../../../../components/Links/ChannelLink/Link";
import { AppContext } from "../../../../components/Menu/MenuButton";
import { Ticket, TicketType } from "../../../../components/TicketsPanel/Ticket";
import { ActionsContext } from "../../../ActionsPage/ACtionsRoutes";
import { TaskContext } from "../../../TaskPage/TasksTypes";
import styles from '../ChallengeDetail.module.scss';

export const SubscriptionRewardDescription = () => {
    return (
        <div className={styles.description}>
            <div className={styles.line}>
                <span>Получайте </span>
                <span className={styles.ticket}>
                    <Ticket type={'rareTickets' as TicketType} value={0} hideValue={true}/>
                </span>
                <span> за выполнение заданий </span>
                <Link
                    path={`/${AppContext.Actions}/${ActionsContext.Tasks}/${TaskContext.JoinChannel}`}
                    text={'«Подписаться на канал»'}
                />
                .
            </div>
            <div>Чем больше каналов и чем дольше вы на них подписаны — тем больше билетов и наград за испытание получаете каждую неделю.</div>
        </div>
    );
}